import { createAsyncThunk } from '@reduxjs/toolkit';
import { ScorecardsActionStoreArgument } from 'store/interfaces';
import api from 'api';
import { API_SCORECARD_DELETE_OWN } from 'constants/api';
import { generateURL } from 'helpers';

export const deleteOwnScorecard = createAsyncThunk<
  {},
  {
    id: number;
    store: ScorecardsActionStoreArgument;
  }
>('scorecards/deleteOwn', async ({ id }, thunkAPI) =>
  api.axios
    .delete(generateURL(API_SCORECARD_DELETE_OWN, { id }))
    .then(({ data }) => ({ data }))
    .catch((e) => thunkAPI.rejectWithValue(e.response?.data)),
);
